
import { mixins, Options } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import { IToken } from '../api/models/token';
import LazyImage from './LazyImage.vue';

@Options({
  components: {
    LazyImage
  },
  props: {
    token: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      required: false
    },
    cta: {
      type: String,
      required: false
    }
  }
})
export default class MToken extends mixins(CampaignWidgetMixin) {
  token: IToken;
  onClick: (token: IToken) => void;
  cta: string;

  clickHandler(token: IToken): void {
    if (this.onClick) {
      this.onClick(token);
    }
  }
}
